import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'PageView',
    component: resolve => require(['@/view/PageView'], resolve),
    children: [{
      path: '/',
      redirect: '/home'
    }, {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/view/HomePage'], resolve),
      meta: {
        title: '深圳華瑞達裝飾集團有限公司'
      }
    }, {
      path: '/survey',
      name: 'survey',
      component: resolve => require(['@/view/Survey'], resolve),
      meta: {
        title: '華瑞達集團 华瑞达概况'
      },
      children: [{
        path: '/',
        name: 'GroupProfile',
        component: resolve => require(['@/view/SurveyItem/GroupProfile'], resolve)
      }, {
        path: '/devHistory',
        name: 'DevHistory',
        component: resolve => require(['@/view/SurveyItem/DevHistory'], resolve)
      }, {
        path: '/companyHonor',
        name: 'CompanyHonor',
        component: resolve => require(['@/view/SurveyItem/CompanyHonor'], resolve)
      }, {
        path: '/culture',
        name: 'Culture',
        component: resolve => require(['@/view/SurveyItem/Culture'], resolve)
      }, {
        path: '/orgStructure',
        name: 'OrgStructure',
        component: resolve => require(['@/view/SurveyItem/OrgStructure'], resolve)
      }, {
        path: '/officemt',
        name: 'Officemt',
        component: resolve => require(['@/view/SurveyItem/Officemt'], resolve)
      }]
    }, {
      path: '/honor',
      name: 'honor',
      component: resolve => require(['@/view/Honor'], resolve),
      meta: {
        title: '華瑞達集團  资质荣誉'
      },
      children: [{
          path: '/',
          name: 'Qualificate',
          component: resolve => require(['@/view/HonorItem/Qualificate'], resolve)
        },
        {
          path: '/certification',
          name: 'Certification',
          component: resolve => require(['@/view/HonorItem/Certification'], resolve)
        }, {
          path: '/certificate',
          name: 'Certificate',
          component: resolve => require(['@/view/HonorItem/Certificate'], resolve)
        }, {
          path: '/designHonor',
          name: 'DesignHonor',
          component: resolve => require(['@/view/HonorItem/DesignHonor'], resolve)
        }, {
          path: '/engineeringHonor',
          name: 'EngineeringHonor',
          component: resolve => require(['@/view/HonorItem/EngineeringHonor'], resolve)
        }
      ]
    }, {
      
      path: '/engineering',
      name: 'engineering',
      component: resolve => require(['@/view/Engineering'], resolve),
      meta: {
        title: '華瑞達集團 經典工程'
      },
      children: [{
          path: '/DesignCase',
          name: 'DesignCase',
          component: resolve => require(['@/view/EngineeringItem/DesignCase'], resolve)
        }, {
          path: '/engineeringDetail',
          name: 'detail',
          component: resolve => require(['@/view/EngineeringItem/detail'], resolve)

        },{
          path: '/',
          name: 'Building',
          component: resolve => require(['@/view/EngineeringItem/Building'], resolve)
        }, {
          path: '/wall',
          name: 'Wall',
          component: resolve => require(['@/view/EngineeringItem/Wall'], resolve)
        }
        ,{
          path: '/Hardcover',
          name: 'Hardcover',
          component: resolve => require(['@/view/EngineeringItem/Hardcover'], resolve)
        }, 
      ]
    }, {
      path: '/join',
      name: 'join',
      component: resolve => require(['@/view/Join'], resolve),
      meta: {
        title: '華瑞達集團 加入华瑞达'
      },
      children: [{
        path: '/',
        name: 'advantages',
        component: resolve => require(['@/view/JoinItem/advantages'], resolve)
      }, {
        path: '/servicePolicy',
        name: 'ServicePolicy',
        component: resolve => require(['@/view/JoinItem/ServicePolicy'], resolve)
      }, {
        path: '/branch',
        name: 'Branch',
        component: resolve => require(['@/view/JoinItem/Branch'], resolve)
      }]
    }, {
      path: '/news',
      name: 'news',
      component: resolve => require(['@/view/News'], resolve),
      meta: {
        title: '華瑞達集團 新闻中心'
      },
      children: [{
        path: '/',
        name: 'CompanyNews',
        component: resolve => require(['@/view/NewsItem/CompanyNews'], resolve)

       
      }, {
        path: '/Industry',
        name: 'Industry',
        component: resolve => require(['@/view/NewsItem/Industry'], resolve)
      }, {
        path: '/newsDetail',
        name: 'NewsDetail',
        component: resolve => require(['@/view/NewsItem/detail'], resolve)
      }]
    }, {
      path: '/resources',
      name: 'resources',
      component: resolve => require(['@/view/Resources'], resolve),
      meta: {
        title: '華瑞達集團  人力资源'
      },
      children: [{
        path: '/',
        name: 'Strategy',
        component: resolve => require(['@/view/ResourcesItem/Strategy'], resolve)
      }, {
        path: '/ranks',
        name: 'Ranks',
        component: resolve => require(['@/view/ResourcesItem/Ranks'], resolve)
      }, {
        path: '/education',
        name: 'Education',
        component: resolve => require(['@/view/ResourcesItem/Education'], resolve)
      }, {
        path: '/recruit',
        name: 'Recruit',
        component: resolve => require(['@/view/ResourcesItem/Recruit'], resolve)
      }]
    }, {
      path: '/contactUs',
      name: 'contactUs',
      component: resolve => require(['@/view/ContactUs'], resolve),
      meta: {
        title: '華瑞達集團 联系我们'
      },
      children: [{
        path: '/',
        name: 'mine',
        component: resolve => require(['@/view/ContactUsItem/mine'], resolve)
      }, {
        path: '/map',
        name: 'map',
        component: resolve => require(['@/view/ContactUsItem/map'], resolve)
      }, {
        path: '/watchOut',
        name: 'WatchOut',
        component: resolve => require(['@/view/ContactUsItem/WatchOut'], resolve)
      }]
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js